/* eslint-disable no-unused-vars */
import { Product } from './product';
import { CaptureMethod, Station, StationType } from './station';
export interface TransactionItem {
  id: number;
  modifiedOn?: string;
  modifiedBy?: string;
  productId?: number;
  product?: Product;
  quantity: number;
  isObserved: boolean;
  itemStatus: ItemStatus;
  captureMethod: CaptureMethod;
  orderHistoryId: number;
  receivedTime: string;
  purchasePrice?: number;
  discountAmount?: number;
  discountType?: 'Percentage' | 'Dollar';
  name?: string;
  taxAmount?: number;
  data?: string;
}

export interface TransactionsRequestPayload {
  storeId?: number | null,
  stationGroupId?: number | null,
  stationId?: number | null,
  limit: number,
  startDate?: string,
  endDate?: string,
  lastTransactionId?: number | null,
  date?: string,
}
export interface Transaction {
  id: number;
  items: TransactionItem[];
  itemsCount: number,
  summary?: string,
  readTime?: number, //in seconds
  readDuration?: number, //in seconds
  station?: Station,
  stationId: string,
  modifiedOn?: string,
  startTime?: string,
  externalId?: string,
  referenceNumber?: string,
  voidedFrom?: string,
  createdOn?: string,
  startedAt?: string,
  completedAt?: string,
  validItemCount?: string,
  storeName?: string,
  stationGroupName?: string,
  stationName?: string,
  status?: OrderStatus,
  transactionDuration?: string,
  paymentDuration?: string,
  updatedReadDuration?: string,
}
export interface TransactionsList {
  page: number,
  totalPages: number,
  totalCount: number,
  rows: Transaction[],
  pageSize: number,
  skip: number,
}
export interface GetTransactionsParams {
  page?: number;
  pageSize?: number;
  orderBy?: string;
  searchTerm?: string;
  filters?: TransactionFilterDto;
  clientId?: number;
}

export interface TransactionFilterDto {
  stationGroupId?: number;
  stationId?: number;
  transactionStartTime?: string;
  itemCount?: number; 
  stationType?: StationType;
  externalId?: string;
  readDuration?: number;
  maxDuration?: number;
  minDuration?: number;
  status?: TransactionStatusFilter;
  startedAt?: {
    from: string;
    to: string;
  };
  validItemCount?: number;
}
export enum TransactionStatusFilter {
  Voided = 'Voided',
  Completed = 'Completed',
}
export enum OrderStatus {
  Open = 'Open', 
  Closed = 'Closed',
  Tender = 'Tender',
  Hold = 'Hold',
  Cancelled = 'Cancelled',
  Returned = 'Returned',
  CancelledByReset = 'CancelledByReset',
  Complete = 'Complete',
  Suspended = 'Suspended',
  Refunded = 'Refunded',
  Review = 'Review',
  Payment = 'Payment',
  Paid = 'Paid'
}
export enum ItemStatus {
  Purchased = 'Purchased',
  Voided = 'Voided', 
  Returned = 'Returned',
  New = 'New'
}
